
<template>
  <section class="default-container">
    <BreadCrumb :bread-crumb="breadCrumb" />
    <div class="content">
      <div class="content-left">
        <div class="left-title">KPI 도서</div>
        <div class="menu-wrap">
          <div v-for="(menu, index) in menuList" :key="'menu' + index" class="menu-item">
            <div :class="['menu-name', {on: menu.selected}]">{{ menu.name }}</div>
            <div v-show="menu.subMenuShow" class="sub-menu__wrap">
              <div v-for="(subMenu, idx) in menu.subMenu" :key="'subMenu' + idx" :class="['sub-menu__item', {on: subMenu.selected}]">
                ・ {{ subMenu.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-right">
        <div class="right-title">
          <div class="right-title__left">
            <kpi-book-icon />
            <div class="title">{{ kpiBook.title }}</div>
          </div>
          <div v-if="kpiBook.previewFilePath" class="is-14m" @click="openPreviewFile">미리보기</div>
        </div>
        <div v-if="kpiBook.isDiscount" class="price-wrap">
          <div class="price-item">
            <div class="is-14b price-title first">KPI회원</div>
            <div class="is-14m price-value first">{{comma(kpiBook.discountPrice)}}원</div>
          </div>
          <div class="price-item">
            <div class="is-14b price-title">인사뱅크 회원</div>
            <div class="is-14m price-value">{{comma(kpiBook.price)}}원</div>
          </div>
        </div>
        <div v-else class="price-wrap">
          <div class="price-info">
            <div class="is-14b price-title first">가격</div>
            <div class="is-14m price-value first">{{comma(kpiBook.price)}}원</div>
          </div>
        </div>
        <img :src="kpiBook.imgPath" alt="kpiBook" class="book-img" />
        <div class="btn-wrap">
          <div class="cart-btn cursor" @click="postCart">
            <cart-icon />
            <div class="is-16b">장바구니 담기</div>
          </div>
          <div class="buy-btn" @click="goKpiPayment">
            <kpi-book-icon fill="#fff" />
            <div class="is-16b">구입하기</div>
          </div>
        </div>
        <div class="detail-subject">도서정보</div>
        <div class="purpose">
          <div class="is-14r">저자 : {{ kpiBook.writer }}</div>
          <div class="is-14r">출판사 : {{ kpiBook.publication }}</div>
          <div class="is-14r">발행 : {{ kpiBook.publisher }}</div>
          <div class="is-14r">발행일 : {{ kpiBook.publicationDate }}</div>
        </div>
        <div class="detail-subject">도서소개</div>
        <div class="purpose" v-html="kpiBook.introduction"/>
        <div class="attach"/>
        <div class="book-list">
          <div v-for="book in bookList" :key="'book' + book.id" class="book-item" @click="goBookDetail(book.id)">
            <img :src="book.imgPath" alt="bookImg" class="book-img" />
            <div class="book-item__right">
              <div class="book-title is-18m">{{ book.title }}</div>
              <div class="is-14r"><strong>저자</strong> : {{ book.writer }}</div>
              <div class="is-14r"><strong>출판사</strong> : {{ book.publication }}</div>
              <div class="is-14r"><strong>발행</strong> : {{ book.publisher }}</div>
              <div class="is-14r"><strong>발행일</strong> : {{ book.publicationDate }}</div>
              <div class="is-14r"><strong>면수</strong> : {{ book.numberOfPages }}</div>
              <div class="is-14r"><strong>규격</strong> : {{ book.specification }}</div>
              <div class="is-14r"><strong>금액</strong> : {{ comma(book.price) }}원</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {useKpiBookStore} from '~/store/kpi-book/index.js'
import {useOrderStore} from '~/store/order/index.js'
import {useMemberStore} from '~/store/member/index.js'
import BreadCrumb from '~/components/common/BreadCrumb.vue'
import KpiBookIcon from 'assets/svg/kpi-book-icon.vue'
import {comma} from '~/utils/function.js'
import CartIcon from 'assets/svg/cart-icon.vue'

export default {
  name: 'SeminarId',
  components: {CartIcon, KpiBookIcon, BreadCrumb},
  setup() {
    const store = useKpiBookStore()
    const orderStore = useOrderStore()
    const memberStore = useMemberStore()
    return {store, orderStore, memberStore}
  },
  data() {
    return {
      comma,
      isAuth: false,
      bookId: null,
      menuList: [
        {
          name: 'KPI 도서',
          selected: false,
          subMenuShow: false,
          subMenu: [{name: 'KPI 도서 리스트', selected: false}]
        }
      ],
      breadCrumb: ['홈', 'KPI 도서'],
      kpiBook: {
        id: 0,
        title: '',
        imgPath: '',
        previewFilePath: '',
        writer: '',
        publisher: '',
        publication: '',
        publicationDate: '',
        numberOfPages: 0,
        specification: '',
        isDiscount: 0,
        price: 0,
        discountType: '',
        discountAmount: 0,
        discountPrice: 0,
        introduction: ''
      },
      bookList: [
        {
          id: 0,
          title: '',
          imgPath: '',
          previewFilePath: '',
          publisher: '',
          writer: '',
          publication: '',
          publicationDate: '',
          numberOfPages: 0,
          specification: '',
          price: 0
        }
      ]
    }
  },
  created() {
    this.bookId = this.$route.params.bookId
  },
  async mounted() {
    this.isAuth = await this.memberStore.isAuthenticated
    await this.getKpiBookDetail()
    await this.getKpiBookList()
  },
  methods: {
    goKpiPayment() {
      if (!this.isAuth) {
        alert('로그인 후 이용가능합니다.')
        return
      }
      this.$router.push(`/kpi-book/payment?bookId=${this.bookId}`)
    },
    goBookDetail(bookId) {
      this.$router.push(`/kpi-book/${bookId}`)
    },
    // 미리보기
    openPreviewFile() {
      if (!this.isAuth) {
        alert('로그인 후 이용가능합니다.')
        return
      }
      window.open(this.kpiBook.previewFilePath)
    },
    async getKpiBookDetail() {
      try {
        const {data} = await this.store.getKpiBookDetail(this.bookId)
        this.kpiBook = data
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
      }
    },
    async getKpiBookList() {
      try {
        const {data} = await this.store.getKpiBookList()
        this.bookList = data
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
      }
    },
    async postCart() {
      if (!this.isAuth) {
        alert('로그인 후 이용가능합니다.')
        return
      }
      try {
        await this.orderStore.postCart({targetId: this.bookId, type: '02'})
        if(confirm('장바구니에 담겼습니다.장바구니로 이동하시겠습니까?')){
          this.$router.push('/cart')
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.detail-subject {
  padding: 12px 0px;
  border-bottom: 2px solid #0058aa;
  color: #0058aa;
  font-family: 'Godo', sans-serif;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 24px;
}
.default-container {
  padding: 48px 0 100px;
  .content {
    display: flex;
    gap: 24px;
    position: relative;
    .content-left {
      min-width: 222px;
      position: sticky;
      top: 40px;
      left: 0;
      height: 600px;
      .left-title {
        color: #121212;
        font-family: 'Godo', sans-serif;
        border-bottom: 1px solid #121212;
        padding-bottom: 24px;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 125%; /* 30px */
      }
      .menu-name {
        padding: 24px;
        border-bottom: 1px solid #dbdbdb;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%; /* 20px */
        cursor: pointer;
        &:hover {
          color: #0058aa;
        }
        &.on {
          font-weight: 700;
          color: #0058aa;
        }
      }
      .sub-menu__item {
        padding: 12px 24px;
        cursor: pointer;
        color: #606060;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%; /* 17.5px */
        &.on {
          font-weight: 700;
          color: #0058aa;
        }
        &:hover {
          background: #f8fbfd;
          color: #0058aa;
        }
        &:last-child {
          border-bottom: 1px solid #dbdbdb;
        }
      }
    }
    .content-right {
      width: 100%;
      .right-title {
        border-top: 1px solid #dbdbdb;
        border-bottom: 1px solid #dbdbdb;
        background: #f8fbfd;
        padding: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;
        .right-title__left {
          display: flex;
          align-items: center;
          gap: 8px;
          .title {
            color: #0058aa;
            font-family: 'Godo', sans-serif;
            font-size: 18px;
            font-weight: 700;
          }
        }
        .is-14m {
          display: flex;
          padding: 7px 12px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          border-radius: 4px;
          border: 1px solid #dbdbdb;
          background: #f2f2f2;
          cursor: pointer;
        }
      }

      .price-wrap{
        border-radius: 4px;
        border: 1px solid #00A5D0;
        display: flex;
        width: 100%;
        margin-bottom: 24px;
        .price-item{
          width: 50%;
          text-align: center;
          .price-title{
            background: #FBFBFB;
            padding: 8px 24px;
            &.first{
              color: #fff;
              background: #00A5D0;
            }
          }
          .price-value{
            padding: 8px 24px;
            &.first{
              color: #00A5D0;
              border-right: 1px solid #00A5D0;
            }
          }
        }
        .price-info{
          width: 100%;
          text-align: center;
          .price-title{
            background: #FBFBFB;
            padding: 8px 24px;
            &.first{
              color: #fff;
              background: #00A5D0;
            }
          }
          .price-value{
            padding: 8px 24px;
            &.first{
              color: #00A5D0;
            }
          }
        }
      }
      .book-img {
        width: 344px;
        height: 516px;
        margin-bottom: 24px;
      }
      .btn-wrap {
        display: flex;
        gap: 8px;
        .cart-btn {
          padding: 12px 24px;
          border-radius: 4px;
          border: 1px solid #dbdbdb;
          background: #f2f2f2;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 24px;
        }
        .buy-btn {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          gap: 8px;
          padding: 12px 24px;
          background: #0058aa;
          color: #fff;
          border-radius: 4px;
          cursor: pointer;
          margin-bottom: 24px;
          .is-16b {
            font-size: 16px;
            font-weight: 700;
            color: #fff;
          }
        }
      }

      .purpose {
        white-space: pre-line;
        font-size: 14px;
        font-weight: 400;
      }
      .attach {
        display: flex;
        padding: 12px 24px;
        align-items: center;
        gap: 16px;
        align-self: stretch;
        border-top: 1px solid #dbdbdb;
        border-bottom: 1px solid #dbdbdb;
        background: #fbfbfb;
        margin: 24px 0;
        .cursor {
          display: flex;
          align-items: center;
          gap: 4px;
        }
      }
      .book-list {
        .book-item {
          cursor: pointer;
          padding: 24px;
          display: flex;
          gap: 16px;
          border-bottom: 1px solid #dbdbdb;

          .book-img {
            width: 142.427px;
            height: 210px;
          }
          .book-item__right {
            .book-title {
              margin-bottom: 12px;
            }
            .is-14r {
              color: #909090;
              margin-bottom: 4px;
              strong {
                color: #121212;
              }
            }
          }
        }
      }
    }
  }
}
</style>
